import React, { useEffect, useRef, useState, useCallback } from "react";
import { useField } from "@unform/core";
import { MdError } from "react-icons/md";
import Tip from "../Tip";

import {
  Container,
  Error,
  RootContainer,
  Label,
  LabelContainer,
  AsteriskText,
  Counter,
  FieldFooter,
} from "./styles";

const InputWithLabel = ({
  name,
  containerStyle = {},
  icon: Icon,
  validationBlur,
  disabled,
  label,
  tip,
  tipAfterInput,
  className,
  maxWidth,
  required,
  maxlength,
  ...rest
}) => {
  const inputRef = useRef(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [fieldLength, setFieldLength] = useState(0);

  const { fieldName, defaultValue, error, registerField } = useField(name);

  const onChangeFieldValue = (input) => {
    setFieldLength(input.target.value.length);
  };

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(async () => {
    let fieldHasValue = !!inputRef.current?.value;
    setIsFocused(false);

    setIsFilled(fieldHasValue);

    if (validationBlur) {
      validationBlur(fieldName, inputRef.current?.value);
    }
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: "value",
    });
    setFieldLength(inputRef.current?.value.length || 0);
  }, [fieldName, registerField]);

  return (
    <RootContainer className={className} maxWidth={maxWidth}>
      <LabelContainer>
        <Label>{label}</Label>
        {required && <AsteriskText>*{` `}</AsteriskText>}
        {tip && <Tip>({tip})</Tip>}
      </LabelContainer>

      <Container
        style={containerStyle}
        isFocused={isFocused}
        isFilled={isFilled}
        isErrored={!!error}
        disabled={disabled}
      >
        <input
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          onChange={onChangeFieldValue}
          defaultValue={defaultValue}
          ref={inputRef}
          disabled={disabled}
          maxlength={maxlength}
          {...rest}
        />
      </Container>
      {tipAfterInput && <Tip>{tipAfterInput}</Tip>}
      {maxlength ? (
        <FieldFooter>
          {error ? (
            <Error title={error}>
              <MdError color="#e00000" size={20} />
              {error}
            </Error>
          ) : (
            <span />
          )}
          <Counter>
            <p>
              {fieldLength}/{maxlength}
            </p>
          </Counter>
        </FieldFooter>
      ) : (
        error && (
          <Error title={error}>
            <MdError color="#e00000" size={20} />
            {error}
          </Error>
        )
      )}
    </RootContainer>
  );
};

export default InputWithLabel;
